import { render, staticRenderFns } from "./BerlianTersediaSubCabangView.vue?vue&type=template&id=59475a10&scoped=true&"
import script from "./BerlianTersediaSubCabangView.vue?vue&type=script&lang=js&"
export * from "./BerlianTersediaSubCabangView.vue?vue&type=script&lang=js&"
import style0 from "./BerlianTersediaSubCabangView.vue?vue&type=style&index=0&id=59475a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59475a10",
  null
  
)

export default component.exports